import React, { ReactElement, ForwardedRef } from 'react';
import { Field } from 'react-final-form';
import FieldMultiSelect from '../field-multi-select/field-multi-select.component';
import FormFieldContainer from '../form-field-container/form-field-container.component';

const FormFieldMultiSelect: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const {
    name,
    children,
    ...custom
  } = props;

  return (
    <FormFieldContainer name={name}>
      <Field
        name={name}
        format={(values: SelectItem[]): SelectItem[] => values || []}
      >
        {
          (fieldProps: ReactComponentProps): ReactElement => (
            <FieldMultiSelect
              withFormHelper
              isPlain={false}
              ref={ref}
              name={name}
              {...fieldProps}
              {...custom}
            >
              {children}
            </FieldMultiSelect>
          )
        }
      </Field>
    </FormFieldContainer>
  );
}));

export default FormFieldMultiSelect;
